import { render, staticRenderFns } from "./c_news.vue?vue&type=template&id=39997a05&scoped=true"
import script from "./c_news.vue?vue&type=script&lang=js"
export * from "./c_news.vue?vue&type=script&lang=js"
import style0 from "./c_news.vue?vue&type=style&index=0&id=39997a05&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39997a05",
  null
  
)

export default component.exports